export default __webpack_public_path__ + "static/media/lining2.a1fbaf07.jpeg";